/**
 * Encode password to base64 for storage/comparison.
 * Note: This is obfuscation, not encryption.
 */
export const encodePassword = (originalPassword: string): string | null => {
  try {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(originalPassword);
    return btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
  } catch {
    return null;
  }
};

/**
 * Decode password from base64.
 * Note: This is de-obfuscation, not decryption.
 */
export const decodePassword = (encodedPassword: string): string | null => {
  if (!encodedPassword) {
    return null;
  }
  try {
    const binaryString = atob(encodedPassword);
    const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
};

const RANDOM_PASSWORD_CHARACTERS = 'abcdefghijklmnopqrstuvwxyz0123456789';

/**
 * Generate cryptographically secure random password with given length.
 */
export const randomPassword = (length: number): string => {
  if (length <= 0) {
    return '';
  }

  const randomValues = new Uint32Array(length);
  crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map(
      value =>
        RANDOM_PASSWORD_CHARACTERS[value % RANDOM_PASSWORD_CHARACTERS.length]
    )
    .join('');
};
